import chatbotStore from '@stores/chatbotStore'
import { observer } from 'mobx-react'

import { ChatWidget } from './components/ChatWidget'
import { IntentResult } from './types/intent'
import './style.scss'

const KawaconnChatbot = observer(() => {
  const handleSendMessage = (message: string) => {
    console.log('New message sent:', message)
  }

  const handleIntentDetected = (result: IntentResult) => {
    console.log('Intent detected:', result)
  }

  // Chỉ hiển thị khi được kích hoạt từ store
  if (chatbotStore.activeChatbot !== 'kawaconn') {
    return null
  }

  return (
    <div className="kawaconn-chatbot-widget">
      <ChatWidget
        onSendMessage={handleSendMessage}
        onIntentDetected={handleIntentDetected}
        onClose={() => chatbotStore.setActiveChatbot(null)}
      />
    </div>
  )
})

export default KawaconnChatbot
